"use client"

import { Box, colors, styled } from "@mui/material";

export const StyledPageLayout = styled(Box)(({ theme }) => ({
  backgroundColor: 'white',
  
  '&, .page-wrapper': {
    //minWidth: '380px',
    width: '100%',
    '.content-wrapper': {
      backgroundColor: 'white',
      position: 'relative',
      width: '100%',
      maxWidth: '900px',
      margin: '0 auto',
      boxSizing: 'border-box',
      padding: theme.spacing(2.3, 2.5, 2),
      '&.content': {
        paddingTop: theme.spacing(1)
      },
      '&.wide': {
        maxWidth: '1366px',
      },
      '&.curved': {
        borderRadius: theme.spacing(4, 0, 0, 0),
        paddingTop: '40px'
      },
      '>.content-wrapper': {
        padding: 0,
        [theme.breakpoints.up('md')]: {
          padding: 0,
        },
      },
    },
  },
  '.nobr': {
    whiteSpace: 'nowrap',
  },
  '.break': {
    wordBreak: 'break-all',
  },
  'sup, sub': {
    fontSize: '60%',
    top: '-.55em',
    position: 'relative',
    verticalAlign: 'baseline',
    lineHeight: '0',
    '&.large, .large': {
      fontSize: '1rem',
    },
  },
  sub: {
    top: 'unset',
    bottom: '-.2rem',
  },
}));
